
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useKits } from "@/hooks/useKits";
import { toast } from "sonner";

interface KitControlLayoutProps {
  children: React.ReactNode;
}

export function KitControlLayout({ children }: KitControlLayoutProps) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { kits } = useKits();
  const kit = kits.find(k => k.id === id);

  React.useEffect(() => {
    if (!kit && kits.length > 0) {
      toast.error("Kit not found");
      navigate("/dashboard");
    }
  }, [kit, kits, navigate]);

  if (!kit) {
    return null;
  }

  return (
    <div className="min-h-screen bg-ticker-bg text-ticker-text">
      <div className="container mx-auto p-2 sm:p-4">
        {children}
      </div>
    </div>
  );
}
